import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setLoadingProducerDeclaration: [],
    setLoadingLastDeclaration: [],
    setLastProducerDeclaration: [],
    setProducerDeclarationList: [],
    declarationHasMoreLoading: [],
    cleanDeclarationList: [],
    setSelectedDeclaration: [],
    setDeclarationDetails: [],
    unsetSelectedDeclaration: [],
    cleanDeclarationDetails: [],
    setLoadingDeclarationDetails: [],
    setNewDeclarationDetails: [],
    setLoadingDeclarationUpdate: [],
    setDeclarationDetailsToast: [],
    setLastFileStatus: [],
    setNormList: [],
    setSelectedNorm: [],
    unsetSelectedNorm: [],
    setLoadingNormDetails: [],
    setNormDetails: [],
    setLoadingNormSave: [],
    setNormDetailsToast: [],
    setLoadNormDetails: [],
    setDeclarationHistoryList: [],
    setDeclarationCsvList: [],
    setDeclarationCsvLoading: [],
    setDownloadDeclarationLoading: [],
	setDownloadDeclarationFile: []
});
 
/**
 * Handlers
 */
const INITIAL_STATE = {
    isLoadingProducerDeclaration: false,
    lastFile: undefined,
    lastFileStatus: '',
    isLoadingLastDeclaration: false,
    page: 1,
    declarationList: [],
    hasMore: true,
	hasMoreIsLoading: false,
    isLoading: false,
    selectedProducerDeclaration: null,
    declarationDetails: {},
    isLoadingDetails: true,
    isLoadingUpdate: false,
    normList: [],
    selectedNorm: null,
    isloadingNormDetails: false,
    normDetails: {},
    isloadingNormSave: false,
    loadNormDetails: null,
    declarationDetailsToast: {
        showToast: false,
        message: '',
        messageType: 'toast-success'
    },
    declarationHistoryList: {
		buscarHistoricoPorPedido: []
	},
    normDetailsToast: {
        showToast: false,
        message: '',
        messageType: 'toast-success'
    },
    declarationCsvList: [],
    declarationCsvLoading: false,
    downloadDeclarationLoading: false,
	downloadDeclarationFile: undefined
};

const setLoadingProducerDeclaration = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingProducerDeclaration: action.payload };
}

const setLoadingLastDeclaration = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingLastDeclaration: action.payload };
}

const setLastProducerDeclaration = (state = INITIAL_STATE, action) => {
    return { ...state, lastFile: action.payload };
}

const setProducerDeclarationList = (state = INITIAL_STATE, action) => {
    return { 
        ...state, 
        declarationList: state.declarationList.concat(action.payload.list),
        hasMore: action.payload.hasMore,
        page: action.payload.page
    };
}

const declarationHasMoreLoading = (state = INITIAL_STATE, action) => {
    return { ...state, hasMoreIsLoading: action.payload };
}

const cleanDeclarationList = (state = INITIAL_STATE) => {
    return { ...state, declarationList: [] };
}

const setSelectedDeclaration = (state = INITIAL_STATE, action) => {
    return { ...state, selectedProducerDeclaration: action.payload };
}

const setDeclarationDetails = (state = INITIAL_STATE, action) => {
    return { ...state, declarationDetails: action.payload };
}

const unsetSelectedDeclaration = (state = INITIAL_STATE) => {
    return { ...state, selectedProducerDeclaration: null};
}

const cleanDeclarationDetails = (state = INITIAL_STATE) => {
    return { ...state, declarationDetails: {} };
}

const setLoadingDeclarationDetails = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingDetails: action.payload };
}

const setNewDeclarationDetails = (state = INITIAL_STATE, action) => {
    return { ...state, declarationDetails: action.payload };
}

const setLoadingDeclarationUpdate = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingUpdate: action.payload };
}

const setDeclarationDetailsToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        declarationDetailsToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

const setLastFileStatus = (state = INITIAL_STATE, action) => {
    return { ...state, lastFileStatus: action.payload };
}

const setNormList = (state = INITIAL_STATE, action) => {
    return { ...state, normList: action.payload };
}

const setSelectedNorm = (state = INITIAL_STATE, action) => {
    return { ...state, selectedNorm: action.payload };
}

const unsetSelectedNorm = (state = INITIAL_STATE, action) => {
    return { ...state, selectedNorm: null };
}

const setLoadingNormDetails = (state = INITIAL_STATE, action) => {
    return { ...state, isloadingNormDetails: action.payload };
}

const setNormDetails = (state = INITIAL_STATE, action) => {
    return { ...state, normDetails: action.payload };
}

const setLoadingNormSave = (state = INITIAL_STATE, action) => {
    return { ...state, isloadingNormSave: action.payload };
}

const setNormDetailsToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        normDetailsToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

const setLoadNormDetails = (state = INITIAL_STATE, action) => {
    return { ...state, loadNormDetails: action.payload };
}

const setDeclarationHistoryList = (state = INITIAL_STATE, action) => {
	return { ...state, declarationHistoryList: action.payload };
}

const setDeclarationCsvList = (state = INITIAL_STATE, action) => {
	return { ...state, declarationCsvList: action.payload };
}

const setDeclarationCsvLoading = (state = INITIAL_STATE, action) => {
	return { ...state, declarationCsvLoading: action.payload };
}

const setDownloadDeclarationLoading = (state = INITIAL_STATE, action) => {
    return { ...state, downloadDeclarationLoading: action.payload };
}

const setDownloadDeclarationFile = (state = INITIAL_STATE, action) => {
    return { ...state, downloadDeclarationFile: action.payload };
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_LOADING_PRODUCER_DECLARATION]: setLoadingProducerDeclaration,
    [Types.SET_LOADING_LAST_DECLARATION]: setLoadingLastDeclaration,
    [Types.SET_LAST_PRODUCER_DECLARATION]: setLastProducerDeclaration,
    [Types.SET_PRODUCER_DECLARATION_LIST]: setProducerDeclarationList,   
    [Types.DECLARATION_HAS_MORE_LOADING]: declarationHasMoreLoading,
    [Types.CLEAN_DECLARATION_LIST]: cleanDeclarationList,
    [Types.SET_SELECTED_DECLARATION]: setSelectedDeclaration,
    [Types.SET_DECLARATION_DETAILS]: setDeclarationDetails,
    [Types.UNSET_SELECTED_DECLARATION]: unsetSelectedDeclaration,  
    [Types.CLEAN_DECLARATION_DETAILS]: cleanDeclarationDetails,
    [Types.SET_LOADING_DECLARATION_DETAILS]: setLoadingDeclarationDetails,
    [Types.SET_NEW_DECLARATION_DETAILS]: setNewDeclarationDetails,
    [Types.SET_LOADING_DECLARATION_UPDATE]: setLoadingDeclarationUpdate,
    [Types.SET_DECLARATION_DETAILS_TOAST]: setDeclarationDetailsToast,
    [Types.SET_LAST_FILE_STATUS]: setLastFileStatus,
    [Types.SET_NORM_LIST]: setNormList,
    [Types.SET_SELECTED_NORM]: setSelectedNorm,
    [Types.UNSET_SELECTED_NORM]: unsetSelectedNorm,
    [Types.SET_LOADING_NORM_DETAILS]: setLoadingNormDetails,
    [Types.SET_NORM_DETAILS]: setNormDetails,    
    [Types.SET_LOADING_NORM_SAVE]: setLoadingNormSave,
    [Types.SET_NORM_DETAILS_TOAST]: setNormDetailsToast,
    [Types.SET_LOAD_NORM_DETAILS]: setLoadNormDetails,
	[Types.SET_DECLARATION_HISTORY_LIST]: setDeclarationHistoryList,
	[Types.SET_DECLARATION_CSV_LIST]: setDeclarationCsvList,
	[Types.SET_DECLARATION_CSV_LOADING]: setDeclarationCsvLoading,
    [Types.SET_DOWNLOAD_DECLARATION_LOADING]: setDownloadDeclarationLoading,
	[Types.SET_DOWNLOAD_DECLARATION_FILE]: setDownloadDeclarationFile,
});
 